export enum SwitchToYearlyModalScreenName {
  SwitchToYearly = 'switch-to-yearly',
}
